export default __webpack_public_path__ + "static/heroSectionBg-c0358e69106199ae823de41865a8f696.png";